import { strapiFetch } from './strapiClient';
import { toPopulateQuery } from './utils';

const NAVIGATION_POPULATE = {
  logoDefault: true,
  logoInverted: true,
  ctaButton: true,
  items: {
    childrenGroups: {
      items: {
        iconImage: true,
      },
    },
  },
};

export const getNavigation = () => {
  const query = toPopulateQuery(NAVIGATION_POPULATE);
  return strapiFetch(`/api/site-navigation?${query}`);
};